import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var GraphQLFragmentError = /*#__PURE__*/function (_Error) {
  function GraphQLFragmentError(message) {
    var _this;
    _classCallCheck(this, GraphQLFragmentError);
    _this = _callSuper(this, GraphQLFragmentError, [message]);
    _this.name = 'GraphQLFragmentError';
    _this.message = message;
    return _this;
  }
  _inherits(GraphQLFragmentError, _Error);
  return _createClass(GraphQLFragmentError);
}( /*#__PURE__*/_wrapNativeSuper(Error));